import _ from 'lodash'
import { PriceCurrency } from '@/plugins/payment'
import Decimal from 'decimal.js'

export function formatPriceValue(price) {
  let parts = price.toFixed(8).split('.')
  if (parts.length !== 2) {
    return price.toString()
  }
  let fraction = parts[1].replace(/0+$/, '')
  if (fraction.length > 0) {
    return parts[0] + '.' + fraction
  } else {
    return parts[0]
  }
}

export function formatPrice(price, currency) {
  if (_.isString(currency)) {
    currency = PriceCurrency[currency]
  }
  if (_.isNil(price)) {
    return null
  }
  let priceDecimal = new Decimal(price).div(currency.unit)
  return formatPriceValue(priceDecimal)
}

export function integerOfPrice(priceStr, currency) {
  if (_.isString(currency)) {
    currency = PriceCurrency[currency]
  }
  if (_.isNil(priceStr) || priceStr === '') {
    return null
  }
  let price = new Decimal(priceStr).times(currency.unit)
  return price.truncated().toNumber()
}

export function formatCurrency(currency) {
  return { CNY: '元' }[currency] || currency
}
